<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel--bg small">
                    <div class="panel__header"></div>
                    <div class="panel__body panel__body--review">
                        <template v-if="state === 'loading'">
                                <div class="spinner"></div>
                        </template>

                        <template v-else-if="state === 'invalid'">
                            <i class="icons icon-close"></i>
                            <p>{{$t('request_review.invalid')}}</p>
                        </template>

                        <template v-else-if="state === 'choice'">
                            <h1>{{$t(isTrajectory ? 'trajectory_review.title' : 'document_review.title') }}</h1>

                            <template v-if="isTrajectory">
                                <p v-if="isClient">{{$t('trajectory_review.client_ready', {counselor: subject.counselor, organisation: subject.organisation})}}</p>
                                <p v-else>{{$t('trajectory_review.employer_ready', {counselor: subject.counselor, client: subject.client, organisation: subject.organisation})}}</p>
                            </template>

                            <template v-if="isDocument">
                                <i class="icons icon-cloud-download" @click="downloadDocument" style="cursor:pointer;"></i>
                                <br/>
                                <a class="button--link inline-block--small" style="color: white; margin: 0;" @click.prevent="downloadDocument">
                                    {{$t('document_review.download_document')}}
                                </a>
                            </template>

                            <p>{{$t('request_review.accept_or_not')}}</p>

                            <button class="button--cta" type="button" @click="accept">{{$t('request_review.accept')}}</button>
                            <button class="button--alt" type="button" @click="reject">{{$t('request_review.reject')}}</button>
                        </template>

                        <template v-else-if="state === 'rejected-reason'">
                            <h1>{{$t('request_review.reject_reason')}}</h1>
                            <p>{{$t('request_review.reject_reason_text_fill')}}</p>

                            <p v-if="isTrajectory && isClient">{{$t('trajectory_review.reject_reason_text_send', {counselor: subject.counselor})}}</p>

                            <form class="form">
                                <div class="form__item">
                                    <label class="form__label">{{$t('request_review.reason')}}</label>
                                    <textarea class="form__input--text" :placeholder="$t('request_review.reject_reason_placehoder')" v-model="rejectionReason" />
                                </div>
                            </form>

                            <button class="button--cta" type="button" @click="sendRejection">{{$t('common.send')}}</button>
                            <button class="button--alt" type="button" @click="goBackToChoice">{{$t('common.back')}}</button>
                        </template>

                        <template v-else-if="state === 'accepted'">
                            <h1>{{$t(isTrajectory ? 'trajectory_review.accepted' : 'document_review.accepted')}}</h1>
                            <i class="icons icon-check"></i>
                            <p>{{$t(isTrajectory ? 'trajectory_review.accepted_text' : 'document_review.accepted_text')}}</p>
                        </template>

                        <template v-else-if="state === 'rejected'">
                            <h1>{{$t(isTrajectory ? 'trajectory_review.rejected' : 'document_review.rejected')}}</h1>
                            <i class="icons icon-close"></i>
                            <p>{{$t(isTrajectory ? 'trajectory_review.rejected_text' : 'document_review.rejected_text')}}</p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { saveFile } from '@/helpers';

    @Component
    export default class ApprovalRequestReview extends Vue {
        name = 'trajectory-review-client';
        state = 'loading';
        isDocument = false;
        isTrajectory = false;
        isClient = true;
        subject = null;
        rejectionReason = '';

        created() {
            this.isDocument = this.$route.name === 'approve-document';
            this.isTrajectory = !this.isDocument;
            this.isClient = this.$route.name === 'review-client';
            this.token = this.$route.params.token;

            if (this.token) {
                this.fetchReviewData();
            } else {
                this.$router.replace({name: 'page_not_found'});
            }
        }

        async fetchReviewData() {
            try {
                let response = await this.axios.get(`/approval-request/${this.token}`);
                this.subject = response.data.subject;
                this.state = 'choice';
            } catch (err) {
                let errorMsg = err.status === 404 && err.errors && err.errors[0] ? err.errors[0] : this.$t('notify.general_error');
                this.$notify.error(errorMsg);
                this.state = 'invalid';
            }
        }

        async accept() {
            try {
                this.state = 'loading';
                let response = await this.axios.post(`/approval-request/${this.token}/accept`, {});
                this.state = 'accepted';
            } catch (err) {
                let errorMsg = err.status === 404 && err.errors && err.errors[0] ? err.errors[0] : this.$t('notify.general_error');
                this.$notify.error(errorMsg);
                this.state = 'choice';
            }
        }

        reject() {
            this.state = 'rejected-reason';
        }

        async sendRejection() {
            try {
                this.state = 'loading';
                let response = await this.axios.post(`/approval-request/${this.token}/reject`, {reason: this.rejectionReason});
                this.rejectionReason = '';
                this.state = 'rejected';
            } catch (err) {
                let errorMsg = err.status === 404 && err.errors && err.errors[0] ? err.errors[0] : this.$t('notify.general_error');
                this.$notify.error(errorMsg);
                this.state = 'choice';
            }
        }

        downloadDocument() {
            const url = `approval-request/${this.token}/download`;
            return this.axios.get(url, {responseType: 'blob'})
                .then(
                    res => saveFile(res.data, this.subject.name, this.subject.mime),
                    err => this.$notify.error(this.$t('notify.download_errror')));
        }

        goBackToChoice() {
            this.rejectionReason = '';
            this.state = 'choice';
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/ApprovalRequestReview.vue